import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import Spinner from '../../_shared/spinner/Spinner';
import { authActions } from '../../_store/actions';

const EpycEntryPoint = () => {
  const { token } = useParams<{ token: string }>();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(new authActions.CheckEpycToken({ token }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return <Spinner />;
};

export default EpycEntryPoint;
